import React from "react";
import { AuditLog } from "@common/types/auditLog";
import styles from "./ChatTaskAuditLog.module.scss";

interface Props {
    log: AuditLog;
    field: string;
    label: string;
}

export const ChatTaskCloseField: React.FC<Props> = ({ log, field, label }) => {
    const diffEntry = log.diff.find((d) => d.field === field);
    const afterLabel = diffEntry?.after?.valueLabel ?? null;
    const beforeLabel = diffEntry?.before?.valueLabel ?? null;

    if (!afterLabel) {
        return (
            <span className={styles.chatTaskMessage}>
                removed the {label}
                {beforeLabel ? (
                    <>
                        &nbsp;<strong>{beforeLabel}</strong>
                    </>
                ) : null}
            </span>
        );
    }

    return (
        <span className={styles.chatTaskMessage}>
            changed the {label} to&nbsp;<strong>{afterLabel}</strong>
        </span>
    );
};
